import { Component, OnInit, Input } from '@angular/core';
import { SectionSocialContainerService } from './section-social-container.service';
import { Observable } from 'rxjs';
import { SectionSocialData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-section-social-container',
  template: `
    <fcp-section-social [sectionSocial]="data | async"></fcp-section-social>
  `
})
export class SectionSocialContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<SectionSocialData>;
  constructor(
    private sectionSocialContainerService: SectionSocialContainerService
  ) {}

  ngOnInit() {
    this.data = this.sectionSocialContainerService.getSocial(this.id);
  }
}
